<template>
  <v-card class="pt-6 pb-3 px-6">
    <v-row>
      <v-col cols="12" lg="2">
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.searchOrder.id')"
          outlined
          single-line
          hide-details
          clearable
          v-model="filterQuery.id"
          autocomplete="off"
        />
      </v-col>
      <v-col cols="12" lg="3">
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.searchOrder.customerName')"
          outlined
          single-line
          hide-details
          clearable
          v-model="filterQuery.customerName"
          autocomplete="off"
        />
      </v-col>
      <v-col cols="12" lg="3">
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.searchOrder.companyName')"
          outlined
          single-line
          hide-details
          clearable
          v-model="filterQuery.companyName"
          autocomplete="off"
        />
      </v-col>
      <v-col cols="12" lg="2">
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.searchOrder.email')"
          outlined
          single-line
          hide-details
          clearable
          v-model="filterQuery.email"
          autocomplete="off"
        />
      </v-col>
      <v-col cols="12" lg="2">
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.searchOrder.phone')"
          outlined
          single-line
          hide-details
          clearable
          v-model="filterQuery.phone"
          autocomplete="off"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" lg="3">
        <v-menu
          v-model="popupFrom"
          :close-on-content-click="false"
          :nudge-right="35"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <div>
              <v-text-field
                :label="$vuetify.lang.t('$vuetify.searchOrder.createdAtFrom')"
                hide-details
                :value="_formatDate(filterQuery.createdAt.from)"
                outlined
                readonly
                v-on="on"
                @click:clear="$set(filterQuery.createdAt, 'from', null)"
                clearable
              />
            </div>
          </template>
          <v-date-picker
            v-model="filterQuery.createdAt.from"
            @input="popupFrom = false"
            locale="cs-CZ"
            :first-day-of-week="1"
          />
        </v-menu>
      </v-col>
      <v-col cols="12" lg="3">
        <v-menu
          v-model="popupTo"
          :close-on-content-click="false"
          :nudge-right="35"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <div>
              <v-text-field
                :label="$vuetify.lang.t('$vuetify.searchOrder.createdAtTo')"
                hide-details
                :value="_formatDate(filterQuery.createdAt.to)"
                outlined
                readonly
                v-on="on"
                @click:clear="$set(filterQuery.createdAt, 'to', null)"
                clearable
              />
            </div>
          </template>
          <v-date-picker
            v-model="filterQuery.createdAt.to"
            @input="popupTo = false"
            locale="cs-CZ"
            :first-day-of-week="1"
          />
        </v-menu>
      </v-col>
      <v-col cols="12" lg="3">
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.searchOrder.priceProm')"
          outlined
          single-line
          hide-details
          clearable
          type="number"
          v-model.number="filterQuery.price.from"
          autocomplete="off"
        />
      </v-col>
      <v-col cols="12" lg="3">
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.searchOrder.priceTo')"
          outlined
          single-line
          hide-details
          clearable
          type="number"
          v-model.number="filterQuery.price.to"
          autocomplete="off"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" lg="2">
        <v-autocomplete
          :items="getCountries"
          outlined
          chips
          small-chips
          :label="$vuetify.lang.t('$vuetify.searchOrder.country')"
          multiple
          hide-details
          @focus="fetchCountries"
          :loading="selectLoading.countries && getCountries.length === 0"
          v-model="filterQuery.countries"
          autocomplete="off"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" lg="2">
        <v-autocomplete
          :items="getCustomerGroups"
          outlined
          chips
          small-chips
          :label="$vuetify.lang.t('$vuetify.searchOrder.customerGroup')"
          multiple
          hide-details
          @focus="fetchCustomerGroups"
          :loading="selectLoading.customerGroups && getCustomerGroups.length === 0"
          v-model="filterQuery.customerGroups"
          autocomplete="off"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" lg="3">
        <v-autocomplete
          :items="getShippingMethods"
          outlined
          small-chips
          :label="$vuetify.lang.t('$vuetify.searchOrder.shippingMethod')"
          @focus="fetchShippingMethods"
          multiple
          hide-details
          :loading="selectLoading.shippingMethods && getShippingMethods.length === 0"
          v-model="filterQuery.shippingMethods"
          autocomplete="off"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" lg="3">
        <v-autocomplete
          :items="shippingOptions"
          outlined
          small-chips
          :label="$vuetify.lang.t('$vuetify.searchOrder.shippingOption')"
          multiple
          hide-details
          :loading="selectLoading.shippingOptions && shippingOptions.length === 0"
          :disabled="noShippingMethodsWithOptions"
          v-model="filterQuery.shippingOptions"
          autocomplete="off"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" lg="2">
        <v-autocomplete
          :items="getPaymentMethods"
          outlined
          small-chips
          :label="$vuetify.lang.t('$vuetify.searchOrder.paymentMethod')"
          @focus="fetchPaymentMethods"
          multiple
          hide-details
          :loading="selectLoading.paymentMethods && getPaymentMethods.length === 0"
          v-model="filterQuery.paymentMethods"
          autocomplete="off"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" lg="3">
        <v-autocomplete
          :items="getOrderStates"
          outlined
          small-chips
          :label="$vuetify.lang.t('$vuetify.searchOrder.status')"
          @focus="fetchOrderStates"
          multiple
          hide-details
          :loading="selectLoading.orderStates && getOrderStates.length === 0"
          v-model="filterQuery.orderStates"
          autocomplete="off"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" lg="2">
        <v-autocomplete
          :items="getBrands"
          outlined
          chips
          small-chips
          :label="$vuetify.lang.t('$vuetify.searchOrder.brandName')"
          hide-details
          @focus="fetchBrands"
          :loading="selectLoading.brands && getBrands.length === 0"
          v-model="filterQuery.brandId"
          autocomplete="off"
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" lg="3">
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.searchOrder.productName')"
          outlined
          single-line
          hide-details
          clearable
          v-model="filterQuery.productName"
          autocomplete="off"
        />
      </v-col>
      <v-col cols="12" lg="2">
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.searchOrder.productSKU')"
          outlined
          single-line
          hide-details
          clearable
          v-model="filterQuery.productSKU"
          autocomplete="off"
        />
      </v-col>
      <v-col cols="12" lg="2">
        <v-text-field
          :label="$vuetify.lang.t('$vuetify.searchOrder.productEan')"
          outlined
          single-line
          hide-details
          clearable
          v-model="filterQuery.productEan"
          autocomplete="off"
        />
      </v-col>
    </v-row>

    <div class="filter-container pt-2">
      <button @click="clear()" class="v-btn v-btn--contained theme--light v-size--default error mt-3 mb-3">
        {{ $vuetify.lang.t('$vuetify.searchOrder.delete_filter') }}
      </button>
      <button
        @click="getItems()"
        ref="getItemsBtn"
        class="v-btn v-btn--contained theme--light v-size--default primary mt-3 mb-3"
      >
        {{ $vuetify.lang.t('$vuetify.searchOrder.filter') }}
      </button>
    </div>
  </v-card>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import { ShippingOptionsApiService } from '@/common/services/shipping-options.api.service';
import TableStateManager from '../../common/helpers/tableStateManager';
import RESOURCES from '../../common/enums/resourceEnum';

const NO_SHIPPING_OPTIONS = 0;

export default {
  name: 'OrdersFilter',

  data() {
    return {
      items: [],
      loading: true,
      selectLoading: {
        brands: false,
        customerGroups: false,
        shippingMethods: false,
        shippingOptions: false,
        paymentMethods: false,
        orderStates: false,
        countries: false,
      },
      popupFrom: false,
      popupTo: false,
      shippingOptions: [],
      filterQuery: { price: {}, createdAt: {} },
    };
  },

  computed: {
    ...mapGetters({
      brands: 'brands/getAllBrands',
      countries: 'countries/getAllCountries',
      customerGroups: 'customerGroups/getAllCustomerGroups',
      shippingMethods: 'shippingMethods/getAllShippingMethods',
      paymentMethods: 'paymentMethods/getAllPaymentMethods',
      orderStates: 'orderStates/getAllOrderStates',
      activeCurrency: 'currencies/getActiveCurrency',
      formLanguage: 'languages/formLanguage',
    }),

    getBrands() {
      if (this.brands) {
        return this.brands.map(curr => ({
          text: curr.name[this.formLanguage],
          value: curr.id,
        }));
      }
      return [];
    },

    getCountries() {
      if (this.countries) {
        return this.countries.map(curr => ({
          text: curr.name,
          value: curr.id,
        }));
      }
      return [];
    },

    getCustomerGroups() {
      if (this.customerGroups) {
        return this.customerGroups.map(curr => ({
          text: curr.name,
          value: curr.id,
        }));
      }
      return [];
    },

    getShippingMethods() {
      if (this.shippingMethods) {
        return this.shippingMethods.map(curr => ({
          text: curr.name[this.formLanguage],
          value: curr.id,
        }));
      }
      return [];
    },

    getPaymentMethods() {
      if (this.paymentMethods) {
        return this.paymentMethods.map(curr => ({
          text: curr.name[this.formLanguage],
          value: curr.id,
        }));
      }
      return [];
    },

    getOrderStates() {
      if (this.orderStates) {
        return this.orderStates.map(curr => ({
          text: curr.label[this.formLanguage],
          value: curr.id,
        }));
      }
      return [];
    },

    shippingMethodsWithOptionsIds() {
      if (!this.filterQuery.shippingMethods || !this.filterQuery.shippingMethods.length) {
        return [];
      }

      return this.shippingMethods
        .filter(
          shippingMethod =>
            this.filterQuery.shippingMethods.includes(shippingMethod.id) &&
            shippingMethod.optionsType !== NO_SHIPPING_OPTIONS
        )
        .map(shippingMethod => shippingMethod.id);
    },

    noShippingMethodsWithOptions() {
      return !this.shippingMethodsWithOptionsIds.length;
    },
  },

  watch: {
    filterQuery: {
      deep: true,
      handler(val) {
        const tableState = TableStateManager.getTableState(RESOURCES.ORDERS);
        const newFilterQuery = Object.entries(val).reduce((acc, [key, value]) => {
          if (!value || (Array.isArray(value) && !value.length)) {
            return acc;
          }
          acc[key] = value;
          return acc;
        }, {});

        TableStateManager.setTableState(RESOURCES.ORDERS, {
          ...tableState,
          filterQuery: newFilterQuery,
        });
      },
    },

    shippingMethodsWithOptionsIds: {
      deep: true,
      handler() {
        this.fetchShippingOptions();
        this.filterSelectedShippingOptions();
      },
    },
  },

  methods: {
    ...mapActions({
      fetchAllBrands: 'brands/fetchAllBrands',
      fetchAllCountries: 'countries/fetchAllCountries',
      fetchAllCustomerGroups: 'customerGroups/fetchAllCustomerGroups',
      fetchAllShippingMethods: 'shippingMethods/fetchAllShippingMethods',
      fetchAllPaymentMethods: 'paymentMethods/fetchAllPaymentMethods',
      fetchAllOrderStates: 'orderStates/fetchAllOrderStates',
    }),

    fetchBrands() {
      this.selectLoading.brands = true;
      this.fetchAllBrands({ options: { pagination: false } });
    },

    fetchCountries() {
      this.selectLoading.countries = true;
      this.fetchAllCountries();
    },

    fetchCustomerGroups() {
      this.selectLoading.customerGroups = true;
      this.fetchAllCustomerGroups({ options: { pagination: false } });
    },

    fetchShippingMethods() {
      this.selectLoading.shippingMethods = true;
      this.fetchAllShippingMethods();
    },

    fetchShippingOptions() {
      if (!this.shippingMethodsWithOptionsIds.length) {
        return;
      }

      this.selectLoading.shippingOptions = true;

      Promise.all(
        this.shippingMethodsWithOptionsIds.map(shippingMethodId => {
          return ShippingOptionsApiService.getAll(shippingMethodId);
        })
      )
        .then(responses => {
          const items = responses.map(response => response.getItems()).flat();
          this.shippingOptions = items.map(shippingOption => {
            return {
              text: shippingOption.name,
              value: shippingOption.id,
            };
          });
        })
        .catch(this._handleError)
        .finally(() => {
          this.selectLoading.shippingOptions = false;
        });
    },

    fetchPaymentMethods() {
      this.selectLoading.paymentMethods = true;
      this.fetchAllPaymentMethods();
    },

    fetchOrderStates() {
      this.selectLoading.orderStates = true;
      this.fetchAllOrderStates();
    },

    filterSelectedShippingOptions() {
      if (this.noShippingMethodsWithOptions) {
        this.$set(this.filterQuery, 'shippingOptions', []);
        return;
      }

      const filteredOptions = this.filterQuery.shippingOptions.filter(shippingOptionId => {
        return !!this.shippingOptions.find(shippingOption => shippingOption.value === shippingOptionId);
      });

      this.$set(this.filterQuery, 'shippingOptions', filteredOptions);
    },

    clear() {
      this.filterQuery = { price: {}, createdAt: {} };
      this.getItems();
    },

    getItems() {
      this.$emit('getItems', this.filterQuery);
      TableStateManager.setTableState(RESOURCES.ORDERS, {
        ...TableStateManager.getTableState(RESOURCES.ORDERS),
        filterQuery: this.filterQuery,
      });
    },

    _handleEnterSubmit(event) {
      const ENTER_KEY_CODE = 13;

      if (event.keyCode === ENTER_KEY_CODE) {
        this.getItems();
      }
    },

    _handleError(response) {
      let message = response.getFirstValidationErrorMessage() || response.getMessage();
      this.$alertError(message);
    },

    _formatDate(date) {
      return date ? moment(date).format('D. M. Y') : '';
    },
  },

  created() {
    const { filterQuery } = TableStateManager.getTableState(RESOURCES.ORDERS);
    this.filterQuery = filterQuery || { price: {}, createdAt: {} };

    if (this.filterQuery.countries && this.filterQuery.countries.length) {
      this.fetchCountries();
    }

    if (this.filterQuery.brands && this.filterQuery.brands.length) {
      this.fetchBrands();
    }

    if (this.filterQuery.customerGroups && this.filterQuery.customerGroups.length) {
      this.fetchCustomerGroups();
    }

    if (this.filterQuery.orderStates && this.filterQuery.orderStates.length) {
      this.fetchOrderStates();
    }

    if (this.filterQuery.shippingMethods && this.filterQuery.shippingMethods.length) {
      this.fetchShippingMethods();
    }

    if (this.filterQuery.paymentMethods && this.filterQuery.paymentMethods.length) {
      this.fetchPaymentMethods();
    }
  },

  mounted() {
    document.addEventListener('keydown', this._handleEnterSubmit);
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this._handleEnterSubmit);
  },
};
</script>

<style lang="scss" scoped>
.filter-container {
  display: flex;
  justify-content: space-between;
}
</style>
